import { memo, useCallback } from 'react';

import { Button } from '../../../Button/Button';
import { ItemButtonProps } from './ItemButton.types';

export const ItemButton = memo<ItemButtonProps>(({ label, value, name, checked, disabled, onClick }) => {
    const handleClick = useCallback(
        (event: React.MouseEvent<HTMLButtonElement>) => {
            onClick(value, event);
        },
        [onClick, value]
    );

    return (
        <Button
            size='small'
            noUppercase
            color={checked ? 'blue80' : 'white100'}
            disabled={disabled}
            onClick={handleClick}
            aria-checked={checked}
            role='checkbox'
            name={name}
            value={value}
            block
        >
            {label}
        </Button>
    );
});

ItemButton.displayName = 'ItemButton';
